import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";
import { OLTheme } from "contexts/Theme/ThemeProvider";

export const useStyles = makeStyles((theme: OLTheme) =>
  createStyles({
    timezoneModalButton: {
      marginTop: theme.spacing(12),
    },
    timezoneModalInfo: {
      fontSize: 14,
      color: theme.gray500,
      lineHeight: theme.spacing(10),
      marginBottom: theme.spacing(12),
    },
    timezoneModal: {
      minWidth: "547px",
    },
  }),
);
